<template>
  <NuxtLink
    v-if="!!blok.url?.cached_url"
    :to="blok.url.cached_url"
    :class="$style['link-image']"
    :target="blok.url.target">

    <picture>
      <source
        media="(width > 50rem)"
        :srcset="imageUrl" />
      <source
        media="(width <= 50rem)"
        v-if="imageMobileUrl"
        :srcset="imageMobileUrl" />
      <img :src="imageUrl" :alt="blok.image?.alt || blok.image?.name || ''" fetchpriority="high" />
  </picture>

  </NuxtLink>
  <picture v-else>
      <source
        media="(width > 50rem)"
        :srcset="imageUrl" />
      <source
        media="(width <= 50rem)"
        v-if="imageMobileUrl"
        :srcset="imageMobileUrl" />
      <img :src="imageUrl" :alt="blok.image?.alt || blok.image?.name || ''" fetchpriority="high" />
  </picture>
</template>
<script setup>
const props = defineProps({ blok: Object })
const img = useImage()
const imageUrl = img(props.blok.image?.filename, { quality: 50, format: 'webp', width: 1200 })
const imageMobileUrl = props.blok.image_mobile?.filename ? img(props.blok.image_mobile.filename, { quality: 50, format: 'webp', width: 800 }) : null

</script>
<style  module>
.link-image {
  display: inline-flex;
  width: 100%;
  height: 100%;
}

.link-image > * {
  object-fit: cover;
  width: 100%;
}
</style>
